var _style, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#A2001D;}\n\t.st3{fill:#F0F0F0;}\n\t.st4{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.6,367.3C502.9,333.6,512,295.9,512,256s-9.1-77.6-25.4-111.3L256,133.6L25.4,144.7 C9.1,178.4,0,216.1,0,256s9.1,77.6,25.4,111.3L256,378.4L486.6,367.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256,0C154.5,0,66.8,59.1,25.4,144.7h461.2C445.2,59.1,357.5,0,256,0L256,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c-101.5,0-189.2-59.1-230.6-144.7h461.2C445.2,452.9,357.5,512,256,512L256,512z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M499.9,178.1H12.1C4.2,202.7,0,228.8,0,256s4.2,53.3,12.1,77.9h487.8c7.8-24.6,12.1-50.7,12.1-77.9 S507.8,202.7,499.9,178.1L499.9,178.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89,244.9H423v22.3H89V244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.6,200.3h244.9v22.3H133.6V200.3z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M380,256c0,0-57.2,66.8-124,66.8S189.2,256,189.2,256s0-66.8,66.8-66.8S380,256,380,256z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256,322.8c-66.8,0-124-66.8-124-66.8s57.2-66.8,124-66.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M211.5,233.7h22.3v44.5h-22.3V233.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M278.3,233.7h22.3v44.5h-22.3V233.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 89,
    cy: 256,
    r: 22.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 423,
    cy: 256,
    r: 22.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/sz.611d213e981ef6b2cc0e5c2dc379ebbc.svg";
export { ForwardRef as ReactComponent };